// 昆仑可复用功能插件
import store from '../store'
import Request from '@/request/index'
import Qs from 'qs'

/**
 * 发起websocket请求函数
 * @param {string} url ws连接地址
 * @param {Object} agentData 传给后台的参数
 * @param {function} successCallback 接收到ws数据，对数据进行处理的回调函数
 * @param {function} errCallback ws连接错误的回调函数
 */
function sendWebsocket (url, agentData, successCallback, errCallback) {
  let websock = null
  var heartCheck = {
    pingTimeout: 15000,
    pongTimeout: 10000,
    pingTimeoutId: null,
    pongTimeoutId: null,
    reset: function () {
      clearInterval(this.pingTimeoutId)
      clearInterval(this.pongTimeoutId)
      return this
    },
    start: function () {
      this.pingTimeoutId = setTimeout(() => {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        // onmessage拿到返回的心跳就说明连接正常
        websock.send(JSON.stringify({
          'id': '1', // 消息id，对应客户端请求消息的id
          'cmd': 'ping' // 回复客户端消息的类型
        }))
        // 如果超过一定时间还没重置，说明后端主动断开了
        this.pongTimeoutId = setTimeout(() => {
          // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          websock.close() // 关闭websocket
          websock.onclose() // 关闭websocket
        }, this.pongTimeout)
      }, this.pingTimeout)
    }
  }
  // let tryTime = null
  // 初始化weosocket
  if (typeof (WebSocket) === 'undefined') {
    // Message.error('您的浏览器不支持WebSocket，无法获取数据')
    return false
  }
  // ws请求完整地址
  websock = new WebSocket(url)
  // 接收ws后端返回的数据
  websock.onmessage = function (e) {
    heartCheck.reset().start()
    successCallback(JSON.parse(e.data))
  }
  // 建立ws连接
  websock.onopen = function () {
    console.log('ws连接成功')
    heartCheck.reset().start()
  }
  // ws连接异常
  websock.onerror = function () {
    console.log('ws连接异常，请稍候重试')
    errCallback()
  }
  // 关闭ws连接
  websock.onclose = function (e) {
    console.log('ws连接关闭')
    console.log(e)
    heartCheck.reset()
    // e.code === 1000  表示正常关闭。 无论为何目的而创建, 该链接都已成功完成任务。
    // e.code !== 1000  表示非正常关闭。
    if (e && e.code !== 1000) {
      // Message.error('ws连接异常，请稍候重试')
      console.log('ws连接失败')
      errCallback()
    }
  }
  // 发起websocket连接
  setTimeout(() => {
    console.log(websock)
    // 添加状态判断，当为OPEN时，发送消息
    if (websock.readyState === websock.OPEN) { // websock.OPEN = 1
      // 发给后端的数据需要字符串化
      // websock.send(JSON.stringify(agentData))
    }
    if (websock.readyState === websock.CLOSED) { // websock.CLOSED = 3
      console.log('websock.readyState=3')
      console.log('ws连接异常，请稍候重试')
    }
  }, 500)
  return websock
}
/**
 * 关闭websocket函数
 */
function closeWebsocket (websock) {
  if (websock) {
    websock.close() // 关闭websocket
    // websock.onclose() // 关闭websocket
  }
}
/**
 * 获取iot平台数据
 * @param {string} gatewayId 一个设备信息
 * @param {function} lastcallback 接收到最新的历史数据，对数据进行处理的回调函数
 * @param {function} successCallback 接收到ws数据，对数据进行处理的回调函数
 */
function getWebsocketData (gatewayId, lastcallback, wsMessage, wsError) {
  // 获取AccessToken
  store.dispatch('getAccessToken')
  // 获取最新的历史数据
  let successCallback = (resp) => {
    lastcallback(resp)
  }
  Request.iotgateway({
    type: 'get',
    headers: {
      Authorization: 'Bearer ' + store.state.accessToken
    },
    url: 'http://' + this.$ENV_IOTURL + '/api/v1/gateways/' + gatewayId + '/metrics/last',
    success: successCallback
  })
  // 链接websocket
  let websocket = sendWebsocket('ws://' + this.$ENV_IOTURL + '/ws?token=' + store.state.accessToken + '&gateway=' +
    gatewayId, {
      'gatewayId': gatewayId
    }, wsMessage, wsError)
  return websocket
}

// 封装文件和其他数据
function setFormData (sendData, fileList, fileSetName) {
  const formData = new FormData()
  if (fileList && fileList.length > 0) {
    for (const file of fileList) {
      formData.append(fileSetName + '[]', file)
    }
  }
  Qs.stringify(sendData, {
      allowDots: true,
      encode: false
    })
    .split('&')
    .map((index) => {
      formData.append(index.split('=')[0], index.split('=')[1])
    })
  return formData
}
function setFormDatas (sendData, fileLists) {
  const formData = new FormData()
  if (fileLists && fileLists.length > 0) {
    for (const fileList of fileLists) {
      for (const file of fileList.data) {
        formData.append(fileList.fileSetName + '[]', file)
      }
    }
  }
  Qs.stringify(sendData, {
      allowDots: true,
      encode: false
    })
    .split('&')
    .map((index) => {
      formData.append(index.split('=')[0], index.split('=')[1])
    })
  return formData
}

function permission (el) {
  if (store.state.isAdmin) {
  } else {
    if (store.state.permission !== 15) {
      el.style.display = 'none'
    }
  }
}

export default {
  install: (Vue, options) => {
    Vue.mixin({
      directives: {
        permission: {
          componentUpdated (el, binding) {
            permission(el)
          }
        }
      },
      methods: {
        getWebsocketData,
        closeWebsocket,
        setFormData,
        setFormDatas
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/kunlun.js